import Contact from 'fitify-ui-landing/src/components/blocks/Document/Contact'
import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import Layout from '@/components/layouts/Layout'
import { getStaticPropsTranslations } from '@/utils/i18n'

const ContactPage: NextPage = () => {
  const { t } = useTranslation()

  return (
    <Layout
      seo={{
        title: t('landing_contact_us') + ' | Fitify',
        description: t('landing_contact_us_meta_description'),
      }}
    >
      <Contact
        title={'landing_contact_us'}
        support={'landing_contact_us_support'}
        socials={'landing_contact_us_facebook_tweet'}
        companyName={'landing_contact_us_company_name'}
        companyAddress={'landing_contact_us_company_address'}
        vat={'landing_contact_us_vat'}
        registered={'landing_contact_us_registered'}
      />
    </Layout>
  )
}

export default ContactPage

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
